/**
 * Unified Zustand store — combines sceneSlice, toolSlice, and uiSlice.
 */
import { create } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';
import { createSceneSlice, type SceneSlice } from './slices/sceneSlice';
import { createSimopsSlice, type SimopsSlice } from './slices/simopsSlice';
import { createToolSlice, type ToolSlice } from './slices/toolSlice';
import { createUiSlice, type UiSlice } from './slices/uiSlice';

// ---------------------------------------------------------------------------
// Combined state type
// ---------------------------------------------------------------------------

export type StoreState = SceneSlice & SimopsSlice & ToolSlice & UiSlice;

// ---------------------------------------------------------------------------
// Store
// ---------------------------------------------------------------------------

export const useStore = create<StoreState>()(
  devtools(
    subscribeWithSelector((...args) => ({
      ...createSceneSlice(...args),
      ...createSimopsSlice(...args),
      ...createToolSlice(...args),
      ...createUiSlice(...args),
    })),
    {
      name: 'KhoriumStore',
    },
  ),
);

// ---------------------------------------------------------------------------
// Re-exports — types and constants consumers need alongside the hook
// ---------------------------------------------------------------------------

export type { SceneSlice } from './slices/sceneSlice';

export type { SimopsSlice } from './slices/simopsSlice';

export type { ToolSlice } from './slices/toolSlice';

export type { UiSlice } from './slices/uiSlice';
